
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/solutions/iot-condition-monitoring/air-quality",
      function () {
        return require("private-next-pages/[locale]/solutions/iot-condition-monitoring/air-quality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/solutions/iot-condition-monitoring/air-quality"])
      });
    }
  